import { observer } from 'mobx-react';
import React from 'react';
import DiscoveryContext from '../../../../../Native/AEP/DiscoveryContext';
import {
  ExperienceSection,
  ExperienceSectionBody,
} from '../../../../../Native/AEP/DiscoveryPortal/Common/ExperienceSection';
import { lookupAndFilter } from '../../../../ExperiencesDictionary';
import { ExperienceDictionaryEntryResponse } from '../../../../ExperiencesDictionary/Types';
import { PortalExperienceProvider } from '../../../PortalExperience/PortalExperienceContextProvider';
import ExperienceTile from '../../ExperienceTiles/ExperienceTile';
import { ProductCollection as ProductCollectionType } from '../types';
import Header from './Header';

interface Props {
  productCollection: ProductCollectionType;
}

function ProductCollection({ productCollection }: Props) {
  const { name, description, id, experiences } = productCollection;
  return (
    <React.Fragment key={productCollection.id}>
      <div className="bg-white shadow-section">
        <DiscoveryContext.Provider
          value={{
            kind: productCollection.kind,
            productCollectionId: productCollection.id,
          }}
        >
          <ExperienceSection>
            <Header name={name} description={description} id={id} />
            <ExperienceSectionBody>
              {/* <ExpandExperiences displayButtonLabel={productCollection.displayButtonLabel}>
                {fromEmpty(filteredExperienceResources)
                  .map(() => (
                    <TileCarouselExperiences
                      invitationUuid={invitationUuid}
                      experienceResources={filteredExperienceResources}
                      perPageCount={productCollection.displayPerPageCount}
                      enrollmentStore={enrollmentStore}
                    />
                  ))
                  .getOrElse(() => (
                    <NoExperiences searchValue={nothing()} />
                  ))}
              </ExpandExperiences> */}
              <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {experiences
                  .reduce(lookupAndFilter, [] as ExperienceDictionaryEntryResponse[])
                  .map((experienceIDResponse) => (
                    <div
                      key={experienceIDResponse.payload.id}
                      className="box-border flex w-full sm:max-w-full xl:min-w-[17rem] xl:max-w-[26.625rem]"
                    >
                      <PortalExperienceProvider
                        experience={experienceIDResponse}
                        key={experienceIDResponse.payload.id}
                      >
                        <ExperienceTile />
                      </PortalExperienceProvider>
                    </div>
                  ))}
              </div>
            </ExperienceSectionBody>
          </ExperienceSection>
        </DiscoveryContext.Provider>
      </div>
    </React.Fragment>
  );
}

export default observer(ProductCollection);
